const translations = {
  "en": {
    "Switch chain failed, please try again": "Switch chain failed, please try again"
  },
  "zh-tw": {
    "Switch chain failed, please try again": "切換公鏈失敗，請重試"
  }
};

export default translations;
